//@ts-check
import React from 'react';
import { getDisplayName } from '../../util';
import Utils from '../../../../utils';
import DropdownButton from '../../../../core/DropdownButton';
import Modals from '../../../../modal';
import useProvider from '../../../../core/EcrionProvider/useProvider';

var formatReaction = function formatReaction(reactionType) {
  if (reactionType === 'positive') return 'Tell us what you like';else return 'Tell us what can be better';
};

var onFeedback = function onFeedback(type, manifest, userInfo) {
  var description = 'We appreciate your feedback. ' + formatReaction(type) + '!';
  Modals.open({
    type: Modals.TYPES.PROMPT_INPUT,
    props: {
      windowProps: {
        header: 'Send Feedback'
      },
      formFieldType: 'Description',
      formField: {
        label: description,
        labelPlacement: 'top',
        name: 'Comment',
        variant: 'filled',
        hideAsterisk: true
      },
      submitLabel: 'Send',
      onSubmit: function onSubmit(description) {
        return Utils.sendFeedbackEmail({
          name: getDisplayName(userInfo),
          email: userInfo.email,
          priority: 'Normal',
          subject: manifest.Name + ' Feedback - ' + formatReaction(type),
          description: description
        });
      }
    }
  });
};

var onAskQuestion = function onAskQuestion() {
  Modals.open({
    type: Modals.TYPES.ASK_QUESTION
  });
};

var NavBarHelpMenu = function NavBarHelpMenu(_ref) {
  var manifest = _ref.manifest,
      userInfo = _ref.userInfo;
  var providerProps = useProvider();
  /**@type {import('core/DropdownButton/types').DropdownButtonProps["options"]} */

  var options = [{
    label: formatReaction('positive') + '...',
    onClick: function onClick() {
      return onFeedback('positive', manifest, userInfo);
    }
  }, {
    label: formatReaction('negative') + '...',
    onClick: function onClick() {
      return onFeedback('negative', manifest, userInfo);
    }
  }, {
    label: 'Ask a Question',
    onClick: onAskQuestion
  }, 'separator', {
    label: 'Help',
    onClick: function onClick() {
      return window.open('https://help.ecrion.com', '_blank');
    }
  }, {
    label: 'Knowledge Base',
    onClick: function onClick() {
      return window.open('https://support.ecrion.com/hc/en-us', '_blank');
    }
  }];

  if (providerProps.guide) {
    options.splice(6, 0, {
      label: 'Restart Guide',
      onClick: function onClick() {
        localStorage.removeItem('ECR.RA.GuideCompleted');
        location.reload();
      }
    });
  }

  return React.createElement(DropdownButton, {
    options: options,
    type: "help",
    style: {
      fontSize: '1rem'
    }
  });
};

export default NavBarHelpMenu;